export enum AnnouncementAudience {
  ALL_USERS = 'ALL_USERS',
  SPECIFIC_BRANCHES = 'SPECIFIC_BRANCHES',
  SPECIFIC_ROLES = 'SPECIFIC_ROLES',
  ALL_CUSTOMERS = 'ALL_CUSTOMERS',
  SPECIFIC_CUSTOMERS = 'SPECIFIC_CUSTOMERS'
}
